import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { rootRoute } from '../../../config';
import { motion } from "framer-motion";
import { play_simulation } from '../services/api';
import { errorMsg } from '../../../helper/helpers';
import Button from '../../common/Button'
import SimProgress from './SimProgress';
import CalProfitLoss from './CalProfitLoss';
import RevenueGraph from './RevenueGraph';
import InventoryGraph from './InventoryGraph';
import ActualDemandGraph from './ActualDemandGraph';
import TrackingGraph from './TrackingGraph';
import { useOutletContext } from "react-router-dom";
import FcModuleStyle from '../styles/fc.module.css';
import info from '../assets/info.png';
import ReactDOM from 'react-dom';
import GraphDataTable from './GraphDataTable';
import MakeaForecast from './MakeaForecast';

const Simulation = () => {
  const [quantity, setQuantity] = useState(50);
  const [shippingType, setShippingType] = useState("NORMAL_SHIPPING");
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError, error, simType, fcPopup, setFcPopup , relaunchPopup, setRelaunchPopup] = useOutletContext();
  const [isDecisionPopup, setIsDecisionPopup] = useState(false);
  const [isShowPlaceOrder, setIsShowPlaceOrder] = useState(false);
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [point, setPoint] = useState(null);
  const [pOrderActivityHeight, setPOrderActivityHeight] = useState(0);
  const [fcProgressPopupTop, setFcProgressPopupTop] = useState(0);
  const [fcMapePopupTop,setFcMapePopupTop] = useState(0);
  const [fcDemandPopupTop, setFcDemandPopupTop] = useState(0);
  const [makeForecastPopupTop, setMakeForecastPopupTop] = useState(0);
  const [forecastPopupTop, setForecastPopupTop] = useState(0);
  const [fcAiPopupTop,setFcAiPopupTop] = useState(0);
  const [fcPricePredPopupTop,setFcPricePredPopupTop] = useState(0);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change

  const showDecisionPopup = () => {
    setIsDecisionPopup(true);
  }
  const hideDecisionPopup = () => {
    setIsDecisionPopup(false);
    var element = document.getElementById('RevenueGraph-Quality');
    element.style.overflow = 'hidden';
  }
  const loadNextPoup = () => {
    setSimPopup(false);
    setIsOverlay(false);
    setIsPopupShown(true);
    if (document.querySelector(".help-link") != null) {
      document.querySelector(".help-link").focus();
    }
  }

  const playSimulation = () => {
    setTimeout(() => {
      setToggleSimulation(true);
    }, 0);
  }

  const resumeSimulation = () => {
    if (!isRequestLoading) {
      setIsRequestLoading(true);
      play_simulation(simObj.sessionid, simObj).then((response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
        }
        else{
        if (typeof response != 'undefined') {
          setSimObj(response?.data);
          setIsShowPlaceOrder(false);
          setIsRequestLoading(false);
          pauseSimulation();
        }
      }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
        console.log(error);
      })
    }
  }

  const pauseSimulation = () => {
    setToggleSimulation(false);
  }
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter((artifact) => artifact.readstatus == 1).length;
    // console.log("readcount:" + readStatusLength)
    if (simObj?.currentstep > 1 || simObj?.attemptno > 1 || readStatusLength > 0) {
      skipWalkThruPopups(false);
    }
  }
  const initSimulation = () => {
    if (!isPopupShown) {
      setIsOverlay(true);
      setHeaderPopup(true)
    }
    setIsArtifacts(true);
  }
  useEffect(() => {
    initSimulation();
    window.$('.ui.accordion').accordion();
    window.$('html, body').animate({
      scrollTop: 0
    }, 100);
    // document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
    document.title = "Forecasting | Simulation";
    document.querySelector("header.header h1.title").focus();
    document.querySelector(".skip-to-main-content-link").style.display = "block";
    if (document.querySelector("#showSummary")) {
      document.querySelector("#showSummary").focus();
    }
    return () => {
      document.querySelector(".skip-to-main-content-link").style.display = "none";
    }
  }, []);

  // useEffect(()=> {
  //   if(fcPopup?.trackSimulation && document.getElementsByClassName("ui pointing label")[0] != null){
  //     let top =document.getElementsByClassName(`${FcModuleStyle['activities']}`)[0].offsetTop + document.getElementsByClassName(`${FcModuleStyle['activities']}`)[0].clientHeight - document.getElementsByClassName("ui pointing label")[0].clientHeight + 10;
  //     setFcProgressPopupTop(top);
  //   }
  // },[fcPopup?.trackSimulation])

  // useEffect(()=>{
  //   if(fcPopup?.mapeReader && document.getElementsByClassName("ui pointing label")[0] != null){
  //     let top = document.getElementsByClassName(`${FcModuleStyle['pl-progress']}`)[0].clientHeight + 5;
  //     setFcMapePopupTop(top);
  //   }
  // },[fcPopup?.mapeReader])

  useEffect(() => {
    const handleResize1 = ()=> {
      // debugger;
      if(fcPopup?.actualDemand && document.getElementsByClassName("ui pointing label")[0] != null){
        let top = document.querySelector("#ActualDemand").clientHeight + 6;
        setFcDemandPopupTop(top);
      }

      if(fcPopup?.mapeReader && document.getElementsByClassName("ui pointing label")[0] != null){
        let top = document.getElementsByClassName(`${FcModuleStyle['pl-progress']}`)[0].clientHeight + 5;
        setFcMapePopupTop(top);
      }

      if(fcPopup?.trackSimulation && document.getElementsByClassName("ui pointing label")[0] != null){
        let top = document.getElementsByClassName(`${FcModuleStyle['sim-progress-activity']}`)[0].offsetTop + document.getElementsByClassName(`${FcModuleStyle['sim-progress-activity']}`)[0].clientHeight;
        setFcProgressPopupTop(top);
      }

      if(fcPopup?.makeForecast && document.getElementsByClassName(`${FcModuleStyle['forecast-popup']}`)[0] != null){
        let top = document.querySelector("#ActualDemand").clientHeight - document.getElementsByClassName(`${FcModuleStyle['forecast-popup']}`)[0].clientHeight - 10;
        setMakeForecastPopupTop(top);
      }
      if(fcPopup?.forecastGraphs && document.getElementsByClassName("ui pointing label")[0] != null){
        let top = document.getElementsByClassName(`${FcModuleStyle['graph-wrapper']}`)[0].offsetTop - document.getElementsByClassName("ui pointing label")[0].clientHeight - 20;
        setForecastPopupTop(top);
      }
      if(fcPopup?.askAi && document.getElementsByClassName("ui pointing label")[0] != null){
        let top = document.getElementsByClassName(`${FcModuleStyle["make-decision-activity"]}`)[0].offsetTop + document.getElementsByClassName(`${FcModuleStyle["make-decision-parent"]}`)[0].offsetTop + document.getElementsByClassName(`${FcModuleStyle['ai-inner-div']}`)[0].clientHeight + 10;
        let target = document.getElementsByClassName(`${FcModuleStyle['make-decision-parent']}`)[0];
        target.scrollTo(500,0)
        setFcAiPopupTop(top);
      }
      if(fcPopup?.pricePrediction && document.getElementsByClassName("ui pointing label")[0] != null){
        let top = document.getElementsByClassName(`${FcModuleStyle["make-decision-activity"]}`)[0].offsetTop + document.getElementsByClassName(`${FcModuleStyle["make-decision-parent"]}`)[0].offsetTop + document.getElementsByClassName(`${FcModuleStyle['ai-inner-div']}`)[0].clientHeight + document.getElementsByClassName(`${FcModuleStyle['prediction-div']}`)[0].clientHeight + 10;
        setFcPricePredPopupTop(top);
      }
    }
    window.addEventListener('resize', handleResize1);
    handleResize1();
  }, [fcPopup?.actualDemand, fcPopup?.mapeReader, fcPopup?.trackSimulation, fcPopup?.makeForecast, fcPopup?.forecastGraphs, fcPopup?.askAi, fcPopup?.pricePrediction]);

  const screenWidth = windowSize;
  const [periodicalType, setPeriodicalType] = useState("monthly");
  const funMonthlyHandler = (e) => {
    setPeriodicalType("monthly");
    setIsDecisionPopup(false);
  }
  const funQuarterlyHandler = (e) => {
    setPeriodicalType("quarterly");
    setIsDecisionPopup(false);
  }
  const funYearlyHandler = (e) => {
    setPeriodicalType("yearly");
    setIsDecisionPopup(false);
  }
  const [periodicalTypeFailure, setPeriodicalTypeFailure] = useState("monthly");
  const funMonthlyHandlerFailure = (e) => {
    setPeriodicalTypeFailure("monthly");
  }
  const funQuarterlyHandlerFailure = (e) => {
    setPeriodicalTypeFailure("quarterly");
  }
  const funYearlyHandlerFailure = (e) => {
    setPeriodicalTypeFailure("yearly");
  }
  const formatNum = (num) => {
    return num?.toLocaleString('en-US', { style: 'decimal' });
  }
  useEffect(() => {
    fuSkipWalkThruPopups();
    // console.log(simObj)
  }, [simObj])

  const functionTabGraphControl = () => {
    class TabsManual {
      constructor(groupNode) {
        this.tablistNode = groupNode;

        this.tabs = [];

        this.firstTab = null;
        this.lastTab = null;

        this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
        this.tabpanels = [];

        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          this.tabpanels.push(tabpanel);

          tab.addEventListener('keydown', this.onKeydown.bind(this));
          tab.addEventListener('click', this.onClick.bind(this));

          if (!this.firstTab) {
            this.firstTab = tab;
          }
          this.lastTab = tab;
        }

        this.setSelectedTab(this.firstTab);
      }

      setSelectedTab(currentTab) {
        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          if (currentTab === tab) {
            tab.setAttribute('aria-selected', 'true');
            tab.removeAttribute('tabindex');
            //this.tabpanels[i].classList.remove('is-hidden');
          } else {
            tab.setAttribute('aria-selected', 'false');
            tab.tabIndex = -1;
            //this.tabpanels[i].classList.add('is-hidden');
          }
        }
      }

      moveFocusToTab(currentTab) {
        currentTab.focus();
      }

      moveFocusToPreviousTab(currentTab) {
        var index;

        if (currentTab === this.firstTab) {
          this.moveFocusToTab(this.lastTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index - 1]);
        }
      }

      moveFocusToNextTab(currentTab) {
        var index;

        if (currentTab === this.lastTab) {
          this.moveFocusToTab(this.firstTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index + 1]);
        }
      }

      /* EVENT HANDLERS */

      onKeydown(event) {
        var tgt = event.currentTarget,
          flag = false;

        switch (event.key) {
          case 'ArrowLeft':
            this.moveFocusToPreviousTab(tgt);
            flag = true;
            break;

          case 'ArrowRight':
            this.moveFocusToNextTab(tgt);
            flag = true;
            break;

          case 'Home':
            this.moveFocusToTab(this.firstTab);
            flag = true;
            break;

          case 'End':
            this.moveFocusToTab(this.lastTab);
            flag = true;
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      // Since this example uses buttons for the tabs, the click onr also is activated
      // with the space and enter keys
      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    }
    // window.addEventListener('load', function () {
    //   var tablists = document.querySelectorAll('[role=tablist].Graphs');
    //   for (var i = 0; i < tablists.length; i++) {
    //     new TabsManual(tablists[i]);
    //   }
    //   if(document.querySelectorAll('.Graphs button') != null){
    //     const elementsWithClassGraphs = document.querySelectorAll('.Graphs button');
    //     elementsWithClassGraphs.forEach(element => {
    //         if (element.getAttribute('aria-selected') === 'false') {
    //             element.setAttribute('tabindex', '-1');
    //         }
    //     });
    //   }
    // });
    const initTabs = () => {
      var tablists = document.querySelectorAll('[role=tablist].Graphs');
      for (var i = 0; i < tablists.length; i++) {
        new TabsManual(tablists[i]);
      }
      if (document.querySelectorAll('.Graphs button') != null) {
        const elementsWithClassGraphs = document.querySelectorAll('.Graphs button');
        elementsWithClassGraphs.forEach(element => {
          if (element.getAttribute('aria-selected') === 'false') {
            element.setAttribute('tabindex', '-1');
          }
        });
      }
    }
    initTabs()
  }
  useEffect(() => {
    functionTabGraphControl();
  }, [])

  const openNewWindow = (data) => {
    const newWindow = window.open('', '_blank', 'width=800,height=800');
    if (newWindow) {
      newWindow.document.open();
      const htmlContentWithNbsp = `
<!DOCTYPE html>
<html>
<head>
    <title>Quality Management</title>
    <link rel="stylesheet" type="text/css" href="https://cdn.datatables.net/1.13.6/css/jquery.dataTables.min.css">
    <style>
          .MainDiv {
              min-height: 620px;
              overflow: hidden;
              width: 95%;
              margin: 0 auto;
          }
          .MainDivChild {
              overflow-x: auto;
              margin: 10px auto;
          }
          table.dataTable thead th {
            border: 1px solid rgba(0, 0, 0, 0.3);
            background-color: #f0f0f0;
          }
          .dataTables_length {
              min-width: 5.5em;
              padding: 10px;
          }
          .dataTables_filter {
            min-width: 5.5em;
            padding: 10px;
            text-align: left;
          }
          .table {
              width: 100%;
              max-width: 100%;
              margin-bottom: 20px;
          }
          .headingh3 {
              color: #002D5F;
              font-weight: 700;
              font-size: 22px;
              background: transparent;
              padding: 0;
          }
          header.header {
            box-shadow: 0px 1px 2px 0px #CCCCCC;
            color: #012F61;
            position: relative;
          }
          header.header>.container {
            margin: 0px 20px;
            display: flex;
            justify-content: space-between;
            min-height: 60px;
            align-items: center;
          }
          header.header>.container h1 {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #b2347b;
          }
          table.dataTable thead th {
              color: #002D5F;
          }
          .header-container header {
          font-size: 12px;
          color: #b2347b;
          }
          .footer {
              background-color: #CDCDCD;
              font-size: 12px;
              padding: 6px;
              text-align: center;
              color: #000000;
          }
          .footer .container {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 82.5%;
              margin: auto;
          }
          .footer .container>div {
              display: flex;
          }
          .footer-links {
              list-style-type: none;
              padding-left: 0;
              padding: 0 5px;
              margin: 0;
              display: flex;
          }
          .footer-links .listitem a {
              text-decoration: underline;
              color: #000000;
          }
          #RevenueGraphData th {
            padding: 4px; 
          }
          #RevenueGraphData tr td:first-child {
            width: 45px; 
          }
    </style>
</head>
<body style="font: 16px/26px 'Roboto', 'Helvetica Neue', Helvetica, Arial; -webkit-font-smoothing: antialiased; font-weight: 300;margin:0;">
<div id="new-component-root"></div>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script src="https://cdn.datatables.net/1.13.6/js/jquery.dataTables.min.js"></script>
<script>
    document.addEventListener('DOMContentLoaded', function() {
        $('#RevenueGraphData').DataTable({
            pagingType: 'full_numbers'
        });
        $('#FailureGraphData').DataTable({
            pagingType: 'full_numbers'
        });
    });
</script>
</body>
</html>
`;
      const htmlContentWithoutNbsp = htmlContentWithNbsp.replace(/&nbsp;/g, ' ');


      newWindow.document.write(htmlContentWithoutNbsp);
      ReactDOM.render(<GraphDataTable type={periodicalType} simObj={simObj} setSimObj={setSimObj} />, newWindow.document.getElementById("new-component-root"));
      newWindow.document.close();
    }
  };

  //Added for stylus tool
  useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
    };
    checkStyleTag();
    // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);

  return (
    <motion.div className={`${FcModuleStyle.simulation} ${FcModuleStyle.container}`} id={`${isStyleTagPresent ? `${FcModuleStyle['fcStylus']}` : ''}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <div className={`${FcModuleStyle.introtext}`}>
        <h2 className={`${FcModuleStyle.heading} ${FcModuleStyle.bgpurple} ${FcModuleStyle.imSim}`}>Simulation</h2>
        <p>To start the simulation, review all communication and documents. You will find key information to assist your success in the simulation. </p>
        {/* Click &nbsp;
        <Link to={`${rootRoute}/${simType?.toLowerCase()}?from=simulation`} style={{'color':'#000','text-decoration':'underline','font-weight':'bold'}}>
          <em className="info circle icon" aria-hidden="true" role="presentation"></em>
          <span>here</span>
        </Link>
        &nbsp;to revisit the tutorial.</p> */}
      </div>
      <div className={`${FcModuleStyle['activities']}`}>
        <div>
          <CalProfitLoss simObj={simObj} setSimObj={setSimObj} fcPopup={fcPopup} setFcPopup={setFcPopup} relaunchPopup={relaunchPopup} setRelaunchPopup={setRelaunchPopup} />
          { 
            fcPopup?.mapeReader ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["mape-reader-popup"]}`} role='dialog' aria-modal="true" aria-label="MAPE reader popup" tabIndex={-1} style={{top: fcMapePopupTop+"px"}}>
              <p>Remember, your goal is to keep your MAPE below {simObj?.mapeToGoal}% to get a contract renewal, and under 10% to get a bonus. Keep an eye on that goal here.</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['mapeReader'] : false}));
                  setRelaunchPopup(true);
                }} />   
              </div>
            </div> : ''
          }
          {
            window.innerWidth>1080 && <hr className={`${FcModuleStyle['hr-bolder']}`} aria-hidden="true" role="presentation"/>
          }
          <SimProgress actions={[playSimulation, resumeSimulation, pauseSimulation, toggleSimulation, setToggleSimulation, isShowPlaceOrder]} popupState={[simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, simObj, setSimObj, getMonth, isLoader, setIsLoader, setError, error, isRequestLoading, fcPopup, setFcPopup]} />
          { 
            fcPopup?.trackSimulation ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["sim-prog-popup"]}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Simulation progress popup" style={{top: fcProgressPopupTop+"px"}}>
              <p>You can keep track of how many months are left here, as well as what month you are currently in. This space will also remind you if it’s time for you to make a new forecast.</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                   window.$("#decisionMain>div:first button:first").click();
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['trackSimulation'] : false, ['askAi']: true }))
                }} />   
              </div>
            </div> : ''
          }

        </div>
        {screenWidth <= 768 &&
          <hr className={`${FcModuleStyle['show-hr']}`} aria-hidden="true" role="presentation"/>
        }
        <div className={`${FcModuleStyle['make-decision-activity']} ${simPopup ? `show ${FcModuleStyle['show']}` : ''}`} style={{ minHeight: pOrderActivityHeight }}>
          {/* <RevenueGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} /> */}
          <div id="ActualDemand" className={`${(fcPopup?.actualDemand) ? `show ${FcModuleStyle['show']}` : ''}`}>
            <h3>Actual Demand in Previous Months</h3>
            <ActualDemandGraph simObj={simObj} setSimObj={setSimObj} />
          </div>
         { 
            fcPopup?.actualDemand ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["actual-demand-popup"]}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Actual demand popup" style={{top: fcDemandPopupTop+"px"}}>
              <p>You can view this graph for useful historical information on actual demand in previous months.</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                  window.$("#decisionMain>div:first button:first").click();
                  window.$(".closeExpertAdviceTaken").click();
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['actualDemand'] : false, ['forecasteDecision']: true }))
                }} />   
              </div>
            </div> : ''
          }
          <hr aria-hidden="true" className={`${FcModuleStyle['hr-bolder']} ${FcModuleStyle['actual-demand-hr']}`} role="presentation"/>
          <MakeaForecast pOrderActivityHeight={pOrderActivityHeight} setPOrderActivityHeight={setPOrderActivityHeight} simObj={simObj} setSimObj={setSimObj} formatNum={formatNum} setError={setError} toggleSimulation={toggleSimulation} setToggleSimulation={setToggleSimulation} isRequestLoading={isRequestLoading} getMonth={getMonth} setIsShowPlaceOrder={setIsShowPlaceOrder} fcPopup={fcPopup} setFcPopup={setFcPopup} skipWalkThruPopups={skipWalkThruPopups} isOverlay={isOverlay} />
          { 
            fcPopup?.makeForecast ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["forecast-popup"]}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Make forecast popup" style={{top: makeForecastPopupTop+"px"}}>
              <p>If you toggle to Past Decisions you can click to a specific month to look at that month’s decisions.</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['makeForecast'] : false, ['trackSimulation']: true }))
                }} />   
              </div>
            </div> : ''
          }
        </div>
        { 
            fcPopup?.askAi ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["ask-ai-popup"]}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Use AI popup" style={{top: fcAiPopupTop+"px", right:"0", left:"auto"}}>
              <p>If you’re stuck, you can Use AI for advice up to three times. Keep in mind, though, AI is not always right.</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['askAi'] : false, ['pricePrediction']: true }))
                }} />   
              </div>
            </div> : ''
          }
          { 
              fcPopup?.pricePrediction ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["price-predict-popup"]}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Price prediction popup" style={{top: fcPricePredPopupTop+"px", right:"0", left:"auto"}}>
              <p>You may also want to consider price predictions, as they may influence your forecast. This price prediction is what your company pays, not what the end consumer will pay.</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                  <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                  <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['pricePrediction'] : false, ['forecastGraphs']: true }))
                  }} />   
              </div>
              </div> : ''
          }
      </div>
      <hr className={`${FcModuleStyle['mt0']} ${FcModuleStyle['hr-bolder']}`} aria-hidden="true" role="presentation" />
      { 
            fcPopup?.forecastGraphs ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["fc-graphs"]} ${FcModuleStyle["graphs-popup"]}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Forecast graphs popup" style={{top: forecastPopupTop+"px"}}>
              <p>These graphs at the bottom of the screen are useful for tracking how well you’re doing with your forecasts.</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['forecastGraphs'] : false, ['demandGraph']: true }))
                }} />   
              </div>
            </div> : ''
          }
      <div className={`${FcModuleStyle['graph-wrapper']} `}>
        <div className={`${fcPopup?.forecastGraphs ? `show ${FcModuleStyle['show']}` : ''}`}>
          <div className={`${FcModuleStyle['_graph']} ${fcPopup?.demandGraph ? `show ${FcModuleStyle['show']}` : ''} `} id="DemandGraph">
            <div className={`${FcModuleStyle['options']}`}>
              <div className={`${FcModuleStyle['demand-heading-container']}`}>
                  <h3 id="Demand" className={`${FcModuleStyle['demand-heading']}`}>Demand</h3>
                  {/* <DropDownMonthRange simObj={simObj} setSimObj={setSimObj}/> */}
              </div>
              {/* <div className={FcModuleStyle['action-buttons']}>
                <div className="tabs">
                <div role="tablist" aria-labelledby="Demand" className="Graphs">
                    <button
                      className={`month ui button ${FcModuleStyle['ui']} ${FcModuleStyle['button']} ${periodicalTypeFailure === "monthly" ? FcModuleStyle['active'] : ''}`}
                      type="button"
                      role="tab"
                      onClick={funMonthlyHandlerFailure}
                      style={{
                        color: periodicalTypeFailure === "monthly" ? "#B90000" : "black",
                        transition: "border-bottom 0.2s",
                        borderBottom: periodicalTypeFailure === "monthly" ? "2px solid #B90000" : "",
                        padding: "4px 11px",
                        borderRadius: 0
                      }}
                      aria-selected={periodicalTypeFailure === 'monthly'}
                      //tabindex={periodicalType === 'monthly' ? "0" : "-1"}
                      aria-controls="tabpanel-4"
                      id="tab-4"
                    >
                      Regular
                    </button>
                    <button
                      className={`quarter ui button ${FcModuleStyle['ui']} ${FcModuleStyle['button']} ${periodicalTypeFailure === "quarterly" ? FcModuleStyle['active'] : ''}`}
                      type="button"
                      role="tab"
                      onClick={funQuarterlyHandlerFailure}
                      style={{
                        color: periodicalTypeFailure === "quarterly" ? "#B90000" : "black",
                        transition: "border-bottom 0.2s",
                        borderBottom: periodicalTypeFailure === "quarterly" ? "2px solid #B90000" : "",
                        padding: "4px 11px",
                        borderRadius: 0
                      }}
                      aria-selected={periodicalTypeFailure === 'quarterly'}
                      //tabindex={periodicalType === 'quarterly' ? "0" : "-1"}
                      aria-controls="tabpanel-5"
                      tabIndex="-1"
                      id="tab-5"
                    >
                      Midgrade
                    </button>
                    <button
                      className={`year ui button ${FcModuleStyle['ui']} ${FcModuleStyle['button']} ${periodicalTypeFailure === "yearly" ? FcModuleStyle['active'] : ''}`}
                      type="button"
                      role="tab"
                      onClick={funYearlyHandlerFailure}
                      style={{
                        color: periodicalTypeFailure === "yearly" ? "#B90000" : "black",
                        transition: "border-bottom 0.2s",
                        borderBottom: periodicalTypeFailure === "yearly" ? "2px solid #B90000" : "",
                        padding: "4px 11px",
                        borderRadius: 0
                      }}
                      aria-selected={periodicalTypeFailure === 'yearly'}
                      //tabindex={periodicalType === 'yearly' ? "0" : "-1"}
                      tabIndex="-1"
                      aria-controls="tabpanel-6"
                      id="tab-6"
                    >
                      Premium
                    </button>
                    <a onClick={() => openNewWindow()} aria-hidden="true" tabIndex="-1" className="sr-only">Open a table version of graphdata</a>
                  </div>
                  
                </div>
              </div> */}
            </div>
            {/* <RevenueGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} /> */}
            <InventoryGraph type={periodicalTypeFailure} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} />
            {/* <div className={`${FcModuleStyle['inventorygraph-legend']}`} aria-hidden="true"><span className={`${FcModuleStyle['inventory-legend']} ${FcModuleStyle['inventorypattern']}`}>&#9632;</span>Failure Rate</div> */}
            {/* <div className={`${FcModuleStyle['main-Demandgraph-legend']}`}>
            <div className={`${FcModuleStyle['Demandgraph-legend']}`} aria-hidden="true">
              <div><span className={`${FcModuleStyle['pattern']} ${FcModuleStyle['revenue-legend']}`}>&#9632;</span><span>Regular Forecasted</span></div>
              <div>
                <span className={`${FcModuleStyle['pattern']} ${FcModuleStyle['cost-legend']}`}>&#9632;</span>
                <span>Regular Actual</span></div>
            </div>
            <div className={`${FcModuleStyle['Demandgraph-legend']}`} aria-hidden="true">
              <div><span className={`${FcModuleStyle['pattern']} ${FcModuleStyle['midgradeforcast-legend']}`}>&#9632;</span><span>Midgrade Forecasted</span></div>
              <div>
                <span className={`${FcModuleStyle['pattern']} ${FcModuleStyle['midgradeactual-legend']}`}>&#9632;</span>
                <span>Midgrade Actual</span></div>
            </div>
            <div className={`${FcModuleStyle['Demandgraph-legend']}`} aria-hidden="true">
              <div><span className={`${FcModuleStyle['pattern']} ${FcModuleStyle['premiumforcast-legend']}`}>&#9632;</span><span>Premium Forecasted</span></div>
              <div>
                <span className={`${FcModuleStyle['pattern']} ${FcModuleStyle['premiumactual-legend']}`}>&#9632;</span>
                <span>Premium Actual</span></div>
            </div>
            </div> */}
            {/* <div className={`${FcModuleStyle['inventorygraph-legend']}`} aria-hidden="true"><span className={`${FcModuleStyle['inventory-legend']} ${FcModuleStyle['inventorypattern']}`}>&#8226;</span>Inventory</div> */}
            {/* <InventoryGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} /> */}
          </div>
          { 
            fcPopup?.demandGraph ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["fc-graphs"]} ${FcModuleStyle["graph1-popup"]}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Demand graph popup">
              <p>The Demand graph shows your forecasted vs actual demand for each gasoline grade in each month. You can hover for more detail, or click the labels in the key to turn a data point off/on. At the top right you can also arrow to the left or right to explore more months of data.</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['demandGraph'] : false, ['absPercentGraph']: true }))
                }} />   
              </div>
            </div> : ''
          }
          {/* <span className={`${FcModuleStyle['seprater']}`}></span> */}
          <div className={`${FcModuleStyle['_graph']} ${fcPopup?.absPercentGraph ? `show ${FcModuleStyle['show']}` : ''} `} id="APERangeGraph">
            <div className={`${FcModuleStyle['options']}`}>
              <h3 id="APE" className={`${FcModuleStyle['APE-heading']}`}>Absolute Percentage Error Range</h3>
              {/* <div className={FcModuleStyle['action-buttons']}>
                <div className="tabs">
                <div role="tablist" aria-labelledby="FailRate" className="Graphs">
                    <button
                      className={`month ui button ${FcModuleStyle['ui']} ${FcModuleStyle['button']} ${periodicalType === "monthly" ? FcModuleStyle['active'] : ''}`}
                      type="button"
                      role="tab"
                      onClick={funMonthlyHandler}
                      style={{
                        color: periodicalType === "monthly" ? "#B90000" : "black",
                        transition: "border-bottom 0.2s",
                        borderBottom: periodicalType === "monthly" ? "2px solid #B90000" : "",
                        padding: "4px 11px",
                        borderRadius: 0
                      }}
                      aria-selected={periodicalType === 'monthly'}
                      //tabindex={periodicalType === 'monthly' ? "0" : "-1"}
                      aria-controls="tabpanel-1"
                      id="tab-1"
                    >
                      Regular
                    </button>
                    <button
                      className={`quarter ui button ${FcModuleStyle['ui']} ${FcModuleStyle['button']} ${periodicalType === "quarterly" ? FcModuleStyle['active'] : ''}`}
                      type="button"
                      role="tab"
                      onClick={funQuarterlyHandler}
                      style={{
                        color: periodicalType === "quarterly" ? "#B90000" : "black",
                        transition: "border-bottom 0.2s",
                        borderBottom: periodicalType === "quarterly" ? "2px solid #B90000" : "",
                        padding: "4px 11px",
                        borderRadius: 0
                      }}
                      aria-selected={periodicalType === 'quarterly'}
                      //tabindex={periodicalType === 'quarterly' ? "0" : "-1"}
                      aria-controls="tabpanel-2"
                      tabIndex="-1"
                      id="tab-2"
                    >
                      Midgrade
                    </button>
                    <button
                      className={`year ui button ${FcModuleStyle['ui']} ${FcModuleStyle['button']} ${periodicalType === "yearly" ? FcModuleStyle['active'] : ''}`}
                      type="button"
                      role="tab"
                      onClick={funYearlyHandler}
                      style={{
                        color: periodicalType === "yearly" ? "#B90000" : "black",
                        transition: "border-bottom 0.2s",
                        borderBottom: periodicalType === "yearly" ? "2px solid #B90000" : "",
                        padding: "4px 11px",
                        borderRadius: 0
                      }}
                      aria-selected={periodicalType === 'yearly'}
                      //tabindex={periodicalType === 'yearly' ? "0" : "-1"}
                      tabIndex="-1"
                      aria-controls="tabpanel-3"
                      id="tab-3"
                    >
                      Premium
                    </button>
                    <a onClick={() => openNewWindow()} aria-hidden="true" tabIndex="-1" className="sr-only">Open a table version of graphdata</a>
                  </div>
                </div>
              </div> */}
              {/* <div className={`${FcModuleStyle['Demandgraph-legend']}`} aria-hidden="true">
                <div><span className={`${FcModuleStyle['pattern']} ${FcModuleStyle['revenue-legend']}`}>&#8226;</span><span>Revenue</span></div>
                <div>
                  <span className={`${FcModuleStyle['pattern']} ${FcModuleStyle['cost-legend']}`}>&#9670;</span>
                  <span>Costs</span></div>

              </div> */}
            </div>
            {/* <RevenueGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} /> */}

            <RevenueGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} />
            {/* <InventoryGraph type={periodicalTypeFailure} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} /> */}

            {/* <div className={`${FcModuleStyle['costquality-legends']}`} aria-hidden="true">
              <div className={`${FcModuleStyle['container-div']}`}>
                <div className={`${FcModuleStyle['circle-line']}`}></div>
                <div className={`${FcModuleStyle['horizontal-line-circle']}`}></div>  
              </div>
              <span>Revenue</span>
              <div className ={`${FcModuleStyle['container-div']}`}>
              <div className ={`${FcModuleStyle['horizontal-line-rhombus']}`}></div>
              <div className ={`${FcModuleStyle['rhombus']}`}></div>
              <div className ={`${FcModuleStyle['circle-rhombus']}`}></div>
              </div>
              <span>Cost of Quality</span>
            </div> */}
          </div>
          { 
            fcPopup?.absPercentGraph ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["fc-graphs"]} ${FcModuleStyle["graph2-popup"]}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Absolute percentage error range graph popup">
              <p>The Absolute Percentage Error Range shows your Absolute Percentage Error for each grade of gasoline each month.</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['absPercentGraph'] : false, ['trackSignalGraph']: true }))
                }} />   
              </div>
            </div> : ''
          }
          { 
            fcPopup?.trackSignalGraph ? <div className={`ui pointing label ${FcModuleStyle.ui} ${FcModuleStyle.pointing} ${FcModuleStyle.label} ${FcModuleStyle["fc-graphs"]} ${FcModuleStyle["graph3-popup"]}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Tracking signal graph popup">
              <p>{"The Tracking Signal graph shows how well you’re doing under-forecasting or over-forecasting for each gasoline grade. You want to stay close to 0%. A TS > 0% means you’re under-forecasting and a TS < 0% means you’re over-forecasting."}</p>
              <div className={`${FcModuleStyle.mt10} ${FcModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnParentClassName={`${FcModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                  setFcPopup((prevFcPopup)=>({...prevFcPopup, ['trackSignalGraph'] : false, ['mapeReader']: true }))
                }} />   
              </div>
            </div> : ''
          }
          <div className={`${FcModuleStyle['_graph']} ${fcPopup?.trackSignalGraph ? `show ${FcModuleStyle['show']}` : ''} `} id="Tracking-signal">
            <div className={`${FcModuleStyle['options']}`}>
              <h3 id="Tracking" className={`${FcModuleStyle['APE-heading']}`}>Tracking Signal</h3>
            </div>
            <TrackingGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} />

          </div>
        </div>
      </div>
    </motion.div>

  )
}

export default Simulation